<template>
  <el-dialog :title="title" :visible.sync="visible" width="50%" :before-close="handleClose">
    <div class="main">
      <lx-transfer v-if="visible" :list="list" @result="getResult"></lx-transfer>
    </div>
    <span slot="footer" class="dialog-footer">
            <el-button @click="handleClose">取 消</el-button>
            <el-button type="primary" @click="handleConfirm">确 定</el-button>
        </span>
  </el-dialog>
</template>
<script>
import LxTransfer from "@/components/LxTransfer/index";

export default {
  name: "LxSort",
  components: {
    LxTransfer,
  },
  props: {
    title: {
      type: String,
      default: "排序",
    },
    visible: {
      type: Boolean,
      default: false,
    },
    list: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      metaList: [],
      result: [],
    };
  },
  methods: {
    handleClose() {
      this.$confirm("确认关闭？").then(() => {
        this.$emit("update:visible", false);
      });
    },
    handleConfirm() {
      const list = this._.cloneDeep(this.result);
      this.$emit("confirm", list);
    },
    // 获取已选择表头
    getResult(list) {
      this.result = list;
    },
  },
};
</script>
<style lang="scss" scoped>
</style>
